import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface ContactusObject {
  id: number;
  name: string;
  email: string;
  phone: string;
  message: string;
}
export interface ContactusListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  contacts: Array<ContactusObject>;
  errors: unknown;
}
@Module
export default class ContactusModule
  extends VuexModule
  implements ContactusListInfo
{
  contacts = [] as Array<ContactusObject>;
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get Contact list
   * @returns Array<BankObject>
   */
  get contactList(): Array<ContactusObject> {
    return this.contacts;
  }

  /**
   * Get total items
   * @returns number
   */
  get contactListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_CONTACTS](data) {
    this.contacts = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_CONTACT_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Action
  [Actions.UPDATE_CONTACT_CURRENT_PAGE](val) {
    // UPDATE_CONTACT_CURRENT_PAGE
    this.context.commit(Mutations.SET_CONTACT_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_CONTACT](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/settings/contact-us', id);
  }

  @Action
  [Actions.GET_CONTACTS]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/settings/contact-us', {
      params: { page: this.currentPage },
    })
      .then(({ data }) => {
        data.data = data.data.map((r) => {
          r.createdAt = new Date(r.createdAt)
            .toLocaleString('en-GB')
            .split(',')[0];
          return r;
        });
        this.context.commit(Mutations.SET_CONTACTS, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }
}
